import React from "react";
import { useSelector } from "react-redux";
import GlobalDeleteDialog from "../../../components/mui/Dialogue/GlobalDeleteDialog";
import {
  deleteCategory,
  getAllCategory,
} from "../../../redux/features/assetManagementSlice";

const Deletecategory = ({ id, data }) => {
  const { loading } = useSelector((state) => state.assetmanagement);
  const { paginationData, openAnchor } = useSelector(
    (state) => state.globalDataGrid
  );

  return (
    <GlobalDeleteDialog
      title={"Delete Category"}
      deleteNote={"Are you sure? you want to delete this category..?"}
      api={deleteCategory(id)}
      upDateCall={getAllCategory(data)}
      loading={loading}
    />
  );
};

export default Deletecategory;
